import _ from 'lodash';
import { createSelector } from 'reselect';
import { CHARGE_INTENT_BY_TYPE } from '../constants/payments';
import {
  isStatusPending,
  isStatusSuccess,
} from '../constants/payment-statuses';
import { STATUSES } from '../redux/actions/payment';

function getPaymentData(state) {
  return state.payment;
}

export const getError = createSelector(getPaymentData, _.property('error'));

export const getOrderId = createSelector(getPaymentData, _.property('orderId'));

export const getPaymentType = createSelector(
  getPaymentData,
  _.property('paymentType'),
);

export const getSelectedMethodId = createSelector(
  getPaymentData,
  _.property('selectedMethod'),
);

export const getAllPaymentMethods = createSelector(
  getPaymentData,
  _.property('paymentMethods'),
);

export const getPaymentMethods = createSelector(
  [getAllPaymentMethods, getPaymentType],
  (orderConfig, paymentType) => {
    const intent = CHARGE_INTENT_BY_TYPE[paymentType];
    return _.filter(orderConfig, (method) =>
      _.includes(method.supportedChargeIntents, intent),
    );
  },
);

export const getSelectedMethod = createSelector(
  [getPaymentMethods, getSelectedMethodId],
  (methods, paymentMethod) => _.find(methods, { paymentMethod }),
);

export const getPaymentStatus = createSelector(
  getPaymentData,
  _.property('status'),
);

export const isPendingPayment = createSelector(
  getPaymentStatus,
  isStatusPending,
);

export const isSuccessPayment = createSelector(
  getPaymentStatus,
  isStatusSuccess,
);

export const getCheckoutInitializationStatus = createSelector(
  getPaymentData,
  _.property('checkoutInitializationStatus'),
);

export const getCheckoutReadyState = createSelector(
  [getCheckoutInitializationStatus],
  (status) => status === STATUSES.DONE || status === STATUSES.FAIL,
);

export const getConfiguredState = createSelector(
  [getPaymentMethods],
  (methods) => Boolean(methods && methods.length),
);
